// Ingtech.responsive = <ta lib></ta>
